import { http } from 'utils'

// Dashboard mutation imports.
import { SET_WIDGETS, SET_DASHBOARD_LISTS, ADD_MESSAGE_DASHBOARD, DASHBOARD_THREAD_UNREAD_COUNT } from 'vx/mutations'
import { findIndex } from 'lodash'

// Dashboard state.
const state = {
  lists: {},
  widgets: {
    pending_count: 0,
    completed_count: 0,
    active_count: 0,
    pending_total: 0,
    completed_total: 0,
    active_total: 0,
    vetting_talent: 0,
    vetting_managers: 0
  }
}

// Dashboard state getters.
const getters = {}

// Dashboard actions.
const actions = {
  getLists ({ commit }) {
    return http.get('dashboard')
      .then((response) => {
        commit(SET_DASHBOARD_LISTS, response.data)

        return response
      })
  },

  getWidgets ({ commit }) {
    return http.get('dashboard/widgets')
      .then((response) => {
        commit(SET_WIDGETS, response.data)

        return response
      })
  },

  /**
   * Add a message to a thread list item on a dashboard
   * @param commit
   * @param payload
   */
  addMessageDashboard ({ commit }, { payload, userId }) {
    commit(ADD_MESSAGE_DASHBOARD, { payload: payload, userId: userId })
  },

  /**
   * Update a threads unread count on a thread list item on a dashboard
   *
   * @param commit
   * @param threadId
   * @param count
   */
  dashboardThreadUnreadCount ({ commit }, threadId, count) {
    commit(DASHBOARD_THREAD_UNREAD_COUNT, threadId, count)
  }
}

// Dashboard state mutations.
const mutations = {
  [SET_DASHBOARD_LISTS] (state, lists) {
    state.lists = lists
  },

  [SET_WIDGETS] (state, widgets) {
    state.widgets = widgets
  },

  [ADD_MESSAGE_DASHBOARD] (state, { payload, userId }) {
    let index = findIndex(state.lists.active_threads, current => current.id === payload.message.thread_id)
    if (index !== -1) {
      state.lists.active_threads[index].latest_message = payload.message
      if (payload.message.user_id !== userId) {
        state.lists.active_threads[index].unread_count = state.lists.active_threads[index].unread_count + 1
      }
    }
  },

  [DASHBOARD_THREAD_UNREAD_COUNT] (state, threadId, count) {
    let index = findIndex(state.lists.active_threads, current => current.id === threadId)
    if (index !== -1) {
      state.lists.active_threads[index].unread_count = count < 0 ? 0 : count
    }
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}
